import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-gauge',
    templateUrl: './gauge.component.html',
    styleUrls: ['./gauge.component.scss'],
    standalone: false
})
export class GaugeComponent {

  @Input() percents: number;
  @Input() color = '#000000';
}
